import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function TestSiteBanner({ visible }) {
  const { t } = useLanguage();

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="test-site-notice"
      className="fixed top-0 left-0 right-0 z-[60] flex min-h-10 items-center justify-center bg-amber-500 px-3 py-2 text-center text-[11px] font-semibold leading-snug text-amber-950 shadow-sm sm:text-xs sm:leading-normal"
    >
      {t('testSiteNotice')}
    </div>
  );
}
